import { ToggleButton } from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import {
  toggleFullScreen,
  toggleScale,
  toggleTheme,
  updateNavigationBarPosition,
} from "@/store/uiPreferences.ts"
import { useAppDispatch, useAppSelector } from "@/store/store.ts"
import { PwaTheme } from "@/components/app/theme/PwaTheme.tsx"
import TextSize from "@spectrum-icons/workflow/TextSize"
import Moon from "@spectrum-icons/workflow/Moon"
import Light from "@spectrum-icons/workflow/Light"
import FullScreen from "@spectrum-icons/workflow/FullScreen"
import FullScreenExit from "@spectrum-icons/workflow/FullScreenExit"
import PaddingBottom from "@spectrum-icons/workflow/PaddingBottom"
import PaddingTop from "@spectrum-icons/workflow/PaddingTop"

export function UiPreferences() {
  const dispatch = useAppDispatch()
  const theme = useAppSelector((state) => state.uiPreferences.theme)
  const scale = useAppSelector((state) => state.uiPreferences.scale)
  const navigationBarPosition = useAppSelector(
    (state) => state.uiPreferences.navigationBarPosition
  )
  const fullScreen = useAppSelector((state) => state.uiPreferences.fullScreen)
  const element = document.documentElement

  function ThemeToggle() {
    return (
      <ToggleButton
        isSelected={false}
        aria-label="Toggle for Theme"
        UNSAFE_style={{ border: "none" }}
        marginX="size-50"
        onPress={() => dispatch(toggleTheme())}
      >
        {theme === "light" && <Moon />}
        {theme === "dark" && <Light />}
      </ToggleButton>
    )
  }

  function FontSizeToggle() {
    return (
      <ToggleButton
        isSelected={scale === "large"}
        aria-label="Toggle for Scale"
        UNSAFE_style={{ border: "none" }}
        marginEnd="size-50"
        onPress={() => dispatch(toggleScale())}
      >
        <TextSize />
      </ToggleButton>
    )
  }

  function NavigationPostionSelect() {
    return (
      <ToggleButton
        aria-label="Toggle for Navigation bar position"
        UNSAFE_style={{ border: "none" }}
        marginEnd="size-50"
        onPress={() => dispatch(updateNavigationBarPosition())}
      >
        {navigationBarPosition === "bottom" && <PaddingBottom/>}
        {navigationBarPosition === "top" && <PaddingTop/>}
      </ToggleButton>
    )
  }

  function FullScreenToggle() {

    async function toggle() {
      if (fullScreen) {
        await document.exitFullscreen()
      } else {
        await element.requestFullscreen()
      }
    }
    return (
      <ToggleButton
        isEmphasized
        isSelected={fullScreen}
        aria-label="Toggle for full screen"
        UNSAFE_style={{ border: "none" }}
        marginEnd="size-50"
        onPress={ () =>{
          void toggle().then(() => { console.log("hello"); })
          dispatch(toggleFullScreen())}}
      >
        {!fullScreen && <FullScreen />}
        {fullScreen && <FullScreenExit />}
      </ToggleButton>
    )
  }

  return (
    <>
      <PwaTheme />
      <ThemeToggle />
      <FontSizeToggle />
      <NavigationPostionSelect />
      <FullScreenToggle />
    </>
  )
}
